
<div class="flex flex-col max-w-300 md:min-w-240 max-h-screen -m-6">
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">Value Break Up</div>
        <button mat-icon-button [tabIndex]="-1" (click)="onClose()">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>
    <div
    class="w-full md:w-auto flex flex-col pt-2 sm:pr-8  md:flex-row space-y-2 md:space-y-0 items-stretch md:items-center justify-end md:space-x-3 flex-shrink-0 pr-2 sm:pb-2">
    <button class="ml-4" mat-flat-button [color]="'primary'" (click)="new()" >
        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
        <span class="ml-2 mr-1">Add</span>
    </button>
    <button class="ml-4" mat-flat-button [color]="'primary'" (click)="deleteSelectedRows()"
        *ngIf="selection.selected.length > 0">
        <mat-icon [svgIcon]="'delete_forever'"></mat-icon>
        <span class="ml-2 mr-1">All Delete</span>
    </button>
</div>
<div class="relative overflow-x-auto  pr-6 sm:pl-8">
    <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <thead class="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-400">
            <tr>
                <th scope="col" class="px-6 py-3 rounded-l-lg">
                    <mat-checkbox (change)="toggleAllRows()" [checked]="isAllSelectedCheckBox"
                        [indeterminate]="selection.hasValue() && !isAllSelected()" [color]="'primary'"
                        [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                </th>
                <th scope="col" class="px-6 py-3 rounded-l-lg">Land Type</th>
                <th scope="col" class="px-6 py-3">Area (In.Sq.Ft)</th>
                <th scope="col" class="px-6 py-3">Rate (In.Rs)</th>
                <th scope="col" class="px-6 py-3">Value (In.Rs)</th>
                <th scope="col" class="px-6 py-3 rounded-r-lg">
                    <span class="sr-only">Actions</span>
                </th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngIf="replacementCostLands$ | async as replacementCostLands">
                <ng-container *ngIf="replacementCostLands.length; else noBuiltUpArea">
                    <ng-container *ngFor="let replacementCostLand of replacementCostLands; trackBy: trackByFn">
                        <tr class="border-b dark:border-gray-700">
                            <td class="px-6 py-2">
                                <mat-checkbox [(checked)]="replacementCostLand.selected" [color]="'primary'"
                                    (change)="updateCheckedList($event,replacementCostLand)"></mat-checkbox>
                            </td>
                            <td class="px-6 py-2">{{replacementCostLand.type}}</td>
                            <td class="px-6 py-2">{{replacementCostLand.area | number : '1.2-2'}}</td>
                            <td class="px-6 py-2">{{replacementCostLand.rate | number : '1.2-2'}}</td>
                            <td class="px-6 py-2">{{replacementCostLand.cost | number : '1.2-2'}}</td>
                            <td class="px-2 py-2 flex items-center justify-end">
                                <button class="ml-2" mat-icon-button>
                                    <mat-icon svgIcon="edit" (click)="edit(replacementCostLand)"></mat-icon>
                                </button>
                                <button class="ml-2" mat-icon-button>
                                    <mat-icon svgIcon="delete_forever"
                                        (click)="delete(replacementCostLand.id)"></mat-icon>
                                </button>
                            </td>
                        </tr>
                    </ng-container>
                </ng-container>
            </ng-container>

            <ng-template #noBuiltUpArea>
                <tr>
                    <td colspan="4" class="text-sm dark:text-gray-400 font-semibold tracking-tight text-center">There
                        are no
                        BuiltUpArea!</td>
                </tr>
            </ng-template>
        </tbody>
        <tfoot>
            <tr class="font-semibold text-gray-900 dark:text-white">
                <th scope="row" class="px-6 py-2 text-base">Total(In Sq.Ft)</th>
                <td> </td>
                <td class="px-6 py-2">
                    <span class="font-medium text-gray-500">Total</span><br />
                    {{totalArea | number:'1.2-2'}}
                </td>
                <td class="px-6 py-2">
                    <span class="font-medium text-gray-500">Avg</span><br />
                    {{avg | number:'1.2-2'}}
                </td>
                
                <td class="px-6 py-2">
                    <span class="font-medium text-gray-500">Total</span><br />
                    {{total | number:'1.2-2'}}
                </td>
            </tr>
        </tfoot>
    </table>
</div>
</div>
